import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {LocateComponent} from "./locate.component";

const routes: Routes = [
  {
    path: '',
    component: LocateComponent
  },
  {
    path: 'list',
    component: LocateComponent
  },
  {
    path: 'menu',
    component: LocateComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LocateRoutingModule {}
